import React from 'react';
import Spinner from 'react-spinkit';

const  Loader = () => {
    return (
        <div className='loading_area'>
          
              <Spinner name="ball-clip-rotate-multiple" />
            

        </div>
    );
};

export default Loader;